module.exports = __webpack_public_path__ + "img/contribute.336d6082.svg";